import React from "react";
import BrandMark from "./BrandMark";
import { useLanguage } from "../i18n/LanguageContext";

export const TELEGRAM_URL = "https://t.me/marsilyabahis";
export const TELEGRAM_HANDLE = "@marsilyabahis";

const SiteFooter = ({ compact = false }) => {
  const { t } = useLanguage();

  return (
    <footer className={`site-footer${compact ? " compact" : ""}`}>
      <div className="site-footer-inner">
        {compact ? null : <BrandMark />}
        <div className="site-footer-copy">
          <span className="site-footer-age">{t("footer.age")}</span>
          <strong>{t("footer.warningTitle")}</strong>
          <p>{t("footer.warning")}</p>
        </div>
      </div>
      <p className="site-footer-rights">{t("footer.rights", { year: new Date().getFullYear() })}</p>
    </footer>
  );
};

export default SiteFooter;
